import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import UserPlatformPhoneHomepageView from "./phone-homepage";
import UserPlatformWebHomepageView from "./web-homepage";
import UserPlatformListView from "./list";
import UserPlatformPhoneThemeManagementView from "./theme-management/phone";
import UserPlatformLiveHomepagesView from "./live-homepages";
import UserPlatformBannerManagementView from "./banner-management";
import UserPlatformContentManagementView from "./content-management";
import SurveyViews from "./surveys";
import DynamicPagesViews from "./dynamic-pages";
import useAccessLevels from "../../../../hooks/use-access-levels";

const UserPlatformViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route, and if its /user-platform, appends /list to it.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.userPlatform.base, exact: true})) {
            if (operatorAccessLevels.packages.clientPlatform.webHomepageEditions
                || operatorAccessLevels.packages.clientPlatform.phoneHomepageEditions) {
                history.replace(routes.userPlatform.list);
            } else if (operatorAccessLevels.packages.clientPlatform.themeManagement) {
                history.replace(routes.userPlatform.themeManagement.phone);
            } else if (operatorAccessLevels.packages.clientPlatform.bannerManagement) {
                history.replace(routes.userPlatform.bannerManagement);
            } else if (operatorAccessLevels.packages.clientPlatform.contentManagement) {
                history.replace(routes.userPlatform.contentManagement);
            } else if (operatorAccessLevels.packages.clientPlatform.surveys) {
                history.replace(routes.userPlatform.surveys.list);
            } else if (operatorAccessLevels.packages.clientPlatform.viewDynamicPages) {
                history.replace(routes.userPlatform.dynamicPages.list);
            } else {
                history.replace(routes.userPlatform.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.clientPlatform.bannerManagement, operatorAccessLevels.packages.clientPlatform.contentManagement, operatorAccessLevels.packages.clientPlatform.phoneHomepageEditions, operatorAccessLevels.packages.clientPlatform.surveys, operatorAccessLevels.packages.clientPlatform.themeManagement, operatorAccessLevels.packages.clientPlatform.viewDynamicPages, operatorAccessLevels.packages.clientPlatform.webHomepageEditions]);

    return (
        <Switch>
            <Route path={routes.userPlatform.base} exact/>
            {
                (operatorAccessLevels.packages.clientPlatform.webHomepageEditions
                    || operatorAccessLevels.packages.clientPlatform.phoneHomepageEditions) &&
                <Route path={routes.userPlatform.list} exact>
                    <UserPlatformListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.phoneHomepageEditions &&
                <Route path={routes.userPlatform.phoneHomepage} exact>
                    <UserPlatformPhoneHomepageView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.webHomepageEditions &&
                <Route path={routes.userPlatform.webHomepage} exact>
                    <UserPlatformWebHomepageView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.themeManagement &&
                <Route path={routes.userPlatform.themeManagement.phone} exact>
                    <UserPlatformPhoneThemeManagementView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.bannerManagement &&
                <Route path={routes.userPlatform.bannerManagement} exact>
                    <UserPlatformBannerManagementView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.contentManagement &&
                <Route path={routes.userPlatform.contentManagement} exact>
                    <UserPlatformContentManagementView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.liveHomepages &&
                <Route path={routes.userPlatform.liveHomepages} exact>
                    <UserPlatformLiveHomepagesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.surveys &&
                <Route path={[
                    routes.userPlatform.surveys.base,
                    routes.userPlatform.surveys.list,
                    routes.userPlatform.surveys.surveyPreview,
                ]} exact>
                    <SurveyViews/>
                </Route>
            }
            {
                operatorAccessLevels.packages.clientPlatform.viewDynamicPages &&
                <Route path={[
                    routes.userPlatform.dynamicPages.base,
                    routes.userPlatform.dynamicPages.list,
                    routes.userPlatform.dynamicPages.single,
                ]} exact>
                    <DynamicPagesViews/>
                </Route>
            }
            <Redirect to={routes.userPlatform.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
}

export default UserPlatformViews;
